import { render, staticRenderFns } from "./canvas.vue?vue&type=template&id=e9fcbc50&scoped=true&"
import script from "./canvas.vue?vue&type=script&lang=js&"
export * from "./canvas.vue?vue&type=script&lang=js&"
import style0 from "./canvas.vue?vue&type=style&index=0&id=e9fcbc50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fcbc50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmtkpv/Projects/barcode-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e9fcbc50', component.options)
    } else {
      api.reload('e9fcbc50', component.options)
    }
    module.hot.accept("./canvas.vue?vue&type=template&id=e9fcbc50&scoped=true&", function () {
      api.rerender('e9fcbc50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/routes/template/canvas.vue"
export default component.exports